import { styled } from '@mui/material/styles';
import { TableRow } from '@mui/material/';

export const StyledTableRow = styled(TableRow)(({ color }) => ({
  td: {
    color: color,
  },
}));
